import PropTypes from 'prop-types';

import i18n from '@/i18n';

import { Skeleton } from '@/components/Skeleton';

import { Container } from '@mui/joy';
import { Smiley } from '@phosphor-icons/react';
import { ArtistCard } from '@/components/ArtistCard';
import { Link } from 'react-router-dom';
import { GenericList } from '@/components/GenericList';
import { useManager } from '@/hooks';

export function ArtistsPage() {
  return (
    <ArtistsContainer />
  )

}

ArtistsPage.propTypes = {
  q: PropTypes.string,
  viewType: PropTypes.string
}

export function ArtistsSkeleton() {
  return (
    <Container>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 10}}>
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
        <Skeleton style={{ width: '100pt', height: '100pt', aspectRatio: '1/1' }} />
      </div>
    </Container>
  )
}

export function ArtistsContainer() {
  const manager = useManager()
  return (
    <Container>
      <GenericList
        path={`/artists`}
        sortByFields={[
          {
            id: 'name',
            name: i18n.t('alphabetically')
          },
          {
            id: '-released',
            name: i18n.t('recent-to-oldest-released')
          }
        ]}
        showDefaultColumns={false}
        columns={[
          {
            id: 'image_url',
            name: i18n.t('image'),
            type: 'image',
            sm: true
          },
          {
            id: 'name',
            name: i18n.t('name'),
            type: 'name',
            sm: true,
            render: ({ node, column }) => <Link to={`/${manager?.type}/${manager?.slug}/artist/${node.id}`}>{node[column.id]}</Link>
          }
        ]}
        canDelete={false}
        canEdit={true}
        canView={true}
        Icon={Smiley}
        addLabel={i18n.t('add-artists')}
        filterPlaceholder={i18n.t('filter-artists')}
        NodeCardComponent={ArtistCard}
        heading={i18n.t('artists')}
        addUrl={`../artist/add`}
        baseUrl={`../artist`}
      />
    </Container>
  )
}

ArtistsContainer.propTypes = {
  q: PropTypes.string,
  viewType: PropTypes.string
}

export default ArtistsPage